.sidebar {
  position: sticky;
  z-index: 10;
  top: var(--space-6);
  align-self: flex-start;

  width: 280px;
  min-width: 280px;
  max-width: 280px;
  flex: 0 0 280px;

  background: var(--color-surface);
  border-right: 1px solid var(--color-border);

  padding: var(--space-8) var(--space-6);
  box-sizing: border-box;

  transition:
    width 0.16s ease,
    min-width 0.16s ease,
    max-width 0.16s ease,
    flex-basis 0.16s ease;
}


.sidebar.closed {
  width: 107px;
  min-width: 107px;
  max-width: 107px;
  flex-basis: 107px;
}

.menuItems {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.menuItem {
  position: relative;
  box-sizing: border-box;

  height: 50px;
  width: 100%;
  padding: 0 var(--space-5);

  display: flex;
  align-items: center;
  justify-content: space-between;

  color: var(--color-text-muted);
  text-decoration: none;

  border-radius: var(--radius-md);

  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);

  transition:
    background-color 0.16s ease,
    color 0.16s ease,
    box-shadow 0.16s ease;
}

.menuItem:hover {
  background: var(--color-surface-subtle);
  color: var(--color-primary);
}

.menuItem.active {
  background: var(--color-primary-subtle);
  color: var(--color-primary);
}

.menuItem.active::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 6px;
  bottom: 6px;

  width: 3px;
  border-radius: var(--radius-full);
  background: var(--color-primary);
}

.iconWrapper {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-width: 0;
}

.iconWrapper svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  color: currentColor;
}

.iconShell {
  position: relative;

  width: 24px;
  height: 24px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;
}

.notificationDot {
  position: absolute;
  top: -6px;
  left: -7px;

  width: 8px;
  height: 8px;

  border-radius: var(--radius-full);
  background: var(--color-notification);

  border: 2px solid var(--color-surface);
  box-sizing: content-box;

  pointer-events: none;
}

.menuItem.active .notificationDot {
  border-color: var(--color-primary-subtle);
}

.itemText {
  white-space: normal;
  line-height: 1.15;
  transition: opacity 0.16s ease;
}

.itemBadge {
  margin-left: var(--space-3);
  padding: 0.35rem 0.55rem;

  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);

  color: var(--color-text-muted);
  font-size: 0.7rem;
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  text-align: center;
  flex: 0.75;

  box-shadow: var(--shadow-sm);
}

.itemCount {
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.45rem;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: var(--color-primary-subtle);
  color: var(--color-text-muted);

  border-radius: var(--radius-full);

  font-size: 0.75rem;
  font-weight: var(--font-weight-semibold);
}

.menuDivider {
  height: 1px;
  background: var(--color-border);
}

.sidebar.closed .itemText,
.sidebar.closed .itemBadge,
.sidebar.closed .itemCount {
  opacity: 0;
  width: 0;
}

.tooltip {
  position: absolute;
  left: calc(100% + var(--space-4));
  top: 50%;
  transform: translateY(-50%);

  background: var(--color-text-dark);
  color: var(--color-primary-text);

  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-sm);

  font-size: var(--font-size-sm);
  white-space: nowrap;

  visibility: hidden;
  opacity: 0;
  pointer-events: none;

  transition:
    opacity 0.16s ease,
    visibility 0.16s ease;

  z-index: 1000;
}

.iconShell:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.collapseButton {
  position: absolute;
  top: var(--space-6);
  right: -16px;
  z-index: 10;

  width: 34px;
  height: 34px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  background: var(--color-surface);
  color: var(--color-text-muted);

  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);

  box-shadow: var(--shadow-sm);
  cursor: pointer;

  transition:
    background-color 0.16s ease,
    color 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    transform 0.16s ease;
}

.collapseButton:hover {
  background: var(--color-primary-subtle);
  color: var(--color-primary);
  border-color: var(--color-primary);
  box-shadow: var(--shadow-md);
}

.collapseButton:focus-visible {
  outline: 3px solid var(--color-focus-ring);
  outline-offset: 2px;
}

.collapseButton svg {
  width: 16px;
  height: 16px;
}

.collapseIcon {
  transition: transform 0.16s ease;
}

.sidebar.closed .collapseIcon {
  transform: rotate(180deg);
}
